import React from "react";
import Chart from "react-apexcharts";

export default function FemaleAreaChart({data}) {


  const names = data.map((n) => n.name);
  const quantities = data.map((n) => n.count);

  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#946A0E"],
    chart: {
      type: "pie",
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const index = opts.seriesIndex;
        const value = quantities[index];
        return `${value}`;
      },
      style: {
        fontSize: "14px",
        colors: ["#fff"],
        fontWeight: "normal",
      },
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val}`;
        },
      },
    },
    stroke: {
      show: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -115,
          },
      },
    },
    responsive: [
      {
        breakpoint: 1500,
        options: {
          chart: {
            width: "300",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: "230",
          },
        },
      },
    ]
  };

  const series = quantities;

  return (
    <Chart
      options={options}
      series={series}
      type="pie"
      width="400"
      className="chart-center"
    />
  );
}
